<template>
    <div class="modal_cont gsrbr0602">
        <div class="modal_header">
            {{ t.MainTitle }}
            <a href="#none" @click="closeModal" class="btn_close">닫기</a>
        </div>

        <div class="modal_content">
            <div class="version_select_area mb40">
                <div class="flex_between">
                    <h3>{{ greeting }}</h3>
                    <!-- <div class="select_group">
                        <SelectBox
                            :options="yearOptions"
                            v-model="selectedYear"
                            class="width_170"
                        />
                        <SelectBox
                            :options="versionOptions"
                            v-model="selectedVersion"
                            class="width_260"
                        />
                    </div> -->
                </div>
            </div>

            <div class="policy_wrap">
                <div v-if="isLoading" class="policy_empty">약관을 불러오는 중입니다.</div>
                <div v-else-if="termsContent" class="policy_html" v-html="termsContent"></div>
                <div v-else class="policy_empty">게시중인 약관이 없습니다.</div>
            </div>

        </div>

        <div class="modal_bottom right">
            <div class="btnBox">
                <Buttons btn-class="btn_big primary" @click="closeModal">확인</Buttons>
            </div>
        </div>
    </div>
</template>

<script>
import modal from "@/utils/popupModal";
import Buttons from "@/components/Buttons.vue";
import { commonAPI } from "@/api/commonAPI.js";

export default {
    name: "gsrbr0602",
    components: {
        Buttons
    },
    data() {
        return {
            selectedYear: "",
            selectedVersion: "",
            termsList: [],
            isLoading: false,
            langData: {
                ko: {
                    MainTitle: "GS ALL 멤버십 회원약관"
                }
            }
        };
    },
    computed: {
        t() {
            return this.langData.ko;
        },
        sortedTermsList() {
            return [...this.termsList].sort((a, b) => {
                const dateA = this.toComparableDate(a.trmsRvsnDt);
                const dateB = this.toComparableDate(b.trmsRvsnDt);

                if (dateA !== dateB) return dateB.localeCompare(dateA);

                return String(b.trmsId || "").localeCompare(String(a.trmsId || ""));
            });
        },
        yearOptions() {
            const years = [...new Set(this.sortedTermsList
                .map((terms) => this.getTermsYear(terms.trmsRvsnDt))
                .filter(Boolean))];

            return years.map((year) => ({ value: year, label: year }));
        },
        versionOptions() {
            return this.sortedTermsList
                .filter((terms) => this.getTermsYear(terms.trmsRvsnDt) === this.selectedYear)
                .map((terms) => ({
                    value: String(terms.trmsId),
                    label: this.getVersionLabel(terms)
                }));
        },
        selectedTerms() {
            return this.sortedTermsList.find((terms) => String(terms.trmsId) === String(this.selectedVersion)) || null;
        },
        greeting() {
            if (!this.selectedTerms?.trmsRvsnDt) return "";

            return `${this.formatDate(this.selectedTerms.trmsRvsnDt)} 개정 및 고시`;
        },
        termsContent() {
            return this.selectedTerms?.hmpgTrmsCntnt || "";
        }
    },
    watch: {
        selectedYear() {
            this.setDefaultVersion();
        }
    },
    mounted() {
        this.selectTerms();
    },
    methods: {
        closeModal(event) {
            modal.close(event.currentTarget);
        },
        async selectTerms() {
            this.isLoading = true;

            try {
                const response = await commonAPI.selectTerms({
                    hmpgTrmsDvCd: "01",
                    trmsExpsrYn: "Y"
                });

                this.termsList = this.getTermsResult(response);
                this.setDefaultSelection();
            } catch (error) {
                // console.error("약관 목록 조회 오류:", error);
                this.termsList = [];
                this.selectedYear = "";
                this.selectedVersion = "";
            } finally {
                this.isLoading = false;
            }
        },
        getTermsResult(response) {
            const result = response?.data?.result;

            if (Array.isArray(response?.data)) return response.data;
            if (Array.isArray(result)) return result;
            if (Array.isArray(result?.list)) return result.list;
            if (Array.isArray(result?.content)) return result.content;
            if (Array.isArray(response?.data?.data)) return response.data.data;

            return [];
        },
        setDefaultSelection() {
            const latestTerms = this.sortedTermsList[0];

            if (!latestTerms) {
                this.selectedYear = "";
                this.selectedVersion = "";
                return;
            }

            this.selectedYear = this.getTermsYear(latestTerms.trmsRvsnDt);
            this.selectedVersion = String(latestTerms.trmsId);
        },
        setDefaultVersion() {
            const hasSelectedVersion = this.versionOptions.some((option) => option.value === String(this.selectedVersion));

            if (hasSelectedVersion) return;

            this.selectedVersion = this.versionOptions[0]?.value || "";
        },
        getTermsYear(date) {
            return this.toComparableDate(date).slice(0, 4);
        },
        getVersionLabel(terms) {
            const dateLabel = this.formatDate(terms.trmsRvsnDt);

            if (dateLabel) return `${dateLabel} 개정 및 고시`;

            return terms.trmsTitle || String(terms.trmsId || "");
        },
        formatDate(date) {
            const comparableDate = this.toComparableDate(date);

            if (!comparableDate) return "";

            return comparableDate.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1.$2.$3");
        },
        toComparableDate(date) {
            return String(date || "").replace(/\D/g, "").slice(0, 8);
        }
    }
};
</script>

<style scoped>
.policy_wrap {margin-top:64px; padding:32px; border:1px solid #E5E5E9; border-radius:12px;}
.policy_html {color:#67676F; font-size:18px; line-height:1.4; overflow-x: visible;}
.policy_html :deep(dl > dt) {margin-bottom:32px; color:#161616; font-size:24px; font-weight:700;}
.policy_html :deep(dl > dd > dl) {margin-bottom:32px;}
.policy_html :deep(dl dd + dt) {margin-top:32px;}
.policy_html :deep(dl > dd > dl > dt) {margin-bottom:0; color:#161616; font-size:18px; font-weight:700;}
.policy_html :deep(dl > dd > dl > dd span) {color:#67676F; font-size:18px; line-height:1.4; display:block;}
.policy_html :deep(dl > dd > dl > dd > ul > li),
.policy_html :deep(ul > li) {color:#67676F; font-size:18px; margin-left:20px; text-indent:-20px; line-height:1.4;}
.policy_html :deep(table) { width: 100%; margin-top: 10px; border-collapse: collapse; word-break: keep-all; }
.policy_html :deep(th),
.policy_html :deep(td) { padding:10px 20px; color:#161616; font-size:18px; border: 1px solid #E5E5E9; line-height:1.5; white-space: normal; word-break: keep-all; }
.policy_html :deep(th) { background-color: #F8F8F8; border-right: 1px solid #E5E5E9; border-top: 1px solid #000000; text-align: center; }
.policy_html :deep(tr th:first-child) { text-align: left; background-color: #F8F8F8; }
.policy_empty {color:#67676F; font-size:18px; line-height:1.4; text-align:center;}
.table_scroll_area { width: 100%; overflow-x: visible; }
h3 { font-size: 32px; font-weight: 700; }
.flex_between { display: flex; justify-content: space-between; align-items: center; }
.select_group { display: flex; gap: 8px; }
.width_170 { width: 170px; }
.width_260 { width: 260px; }
p {margin-top:4px; font-size:18px; color: #fb6432 !important; }
.btn-wrap {display:flex; justify-content:flex-end;}

@media screen and (max-width: 1024px) {
    .table_scroll_area { overflow-x: auto; -webkit-overflow-scrolling: touch; }
    .table_scroll_area table { min-width: 1000px; }
    .policy_html { overflow-x: auto; -webkit-overflow-scrolling: touch; }
    .policy_html :deep(table) { min-width: 1000px; }
}

@media screen and (max-width: 767px) {
    h3 {font-size:24px;}
    .policy_wrap {padding:0px; border:0;}
    .policy_html :deep(dl > dt) {margin-bottom:24px; font-size:20px;}
    .policy_html,
    .policy_empty,
    .policy_html :deep(dl > dd > dl > dd span),
    .policy_html :deep(dl > dd > dl > dd > ul > li),
    .policy_html :deep(p),
    .policy_html :deep(.desc),
    .policy_html :deep(th),
    .policy_html :deep(td) {font-size:16px;}
    .policy_html :deep(dd .desc) {margin-bottom:8px; font-size:16px;}
    .flex_between {display:flex; flex-direction:column; align-items:stretch;}
    .select_group {margin-top:32px; flex-direction:column;}
    .width_170, .width_260 {width:100%;}
    .policy_html :deep(dl > dd > dl > dt) {margin-bottom:0; font-size:16px;}
}
</style>
